import { values } from '@fortem-monorepo/js-utilities';
export const PRODUCT_RESULT = {
    Flow: 'flow',
    Wrapped: 'wrapped',
    AsIs: 'as_is',
};
export const PRODUCT_RESULTS = values(PRODUCT_RESULT);
